export default function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@popperjs/core/lib/utils/getMainAxisFromPlacement.js
// module id = 165
// module chunks = 0